export default __webpack_public_path__ + "static/media/hajB.3b6491a3.jpg";